import { useMutation, useQueryClient } from 'react-query';
import { API } from 'api';
import { getLatestQuery } from 'common';
import { toastPush } from 'modules';
import { useDispatch } from 'react-redux';

export interface IExceptionReportData {
  payload: {
    fileName: string;
    data: string;
    type: string;
  };
}

const addExceptionReportData = (payload: IExceptionReportData['payload']) => {
  const formData = new FormData();
  formData.append('data', payload.data || '');
  formData.append('type', payload.type || '');
  return API.newPost('/api/admin/financeFiles/HLBB', formData, {
    'Content-Type': 'multipart/form-data',
  });
};

export const useAddExceptionReportData = () => {
  const queryClient = useQueryClient();
  const queryArr = queryClient.getQueriesData('exceptionalFiles');
  const res = getLatestQuery(queryArr, queryClient);
  const dispatch = useDispatch();

  return useMutation(addExceptionReportData, {
    onSuccess: () => {
      dispatch(
        toastPush({
          code: 200,
          type: 'success',
          title: 'SUCCESS',
          body: 'toastPush.createdSuccessful',
        })
      );
      return queryClient.invalidateQueries('exceptionalFiles', res.queryParams);
    },
  });
};
